import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import P1 from '../typography/paragraphs/P1'

const LevelIconContainer = styled.div`
  flex: 0 0 39px;
  border-radius: 5.6px;
  display: inline-block;
  line-height: 39px;
`

const LevelIconTop = styled.div`
  width: 100%;
  height: 10px;
  background-color: ${props => `#${props.color}`};
  border-radius: 5.6px 5.6px 0 0;
`

const LevelIconBody = styled.div`
  background: white;
  box-sizing: border-box;
  height: 28px;
  width: 100%;
  border: 1.12px solid #dedfe0;
  border-top: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 0 5.6px 5.6px;
`

const LevelIcon = ({ color, level }) => (
  <LevelIconContainer>
    <LevelIconTop color={color} />
    <LevelIconBody>
      <P1>{level.number}</P1>
    </LevelIconBody>
  </LevelIconContainer>
)

LevelIcon.propTypes = {
  level: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired
}

export default LevelIcon



// WEBPACK FOOTER //
// ./src/components/productionstatus/LevelIcon.js